/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import IosSwitchMain from "../../components/iosSwitchMain";
import MenuIcon from "@mui/icons-material/Menu";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useEffect, useState } from "react";
import {
  useLazyGetButterflyShowHideQuery,
  useSetButterflyOrderMutation,
} from "../../service/offer";
import { showError, showToast } from "../../constants/toasts";
import { formatDubaiDateTime } from "../../utils/dateTime";

function DraggableRow({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      hover
    >
      {children}
    </TableRow>
  );
}

const ButterflyEffectTable = ({
  data,
  setData,
  butterflyEffectApi,
}: {
  data: any[];
  setData: any;
  butterflyEffectApi: () => void;
}) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [setOrder] = useSetButterflyOrderMutation();
  const [changeStatus] = useLazyGetButterflyShowHideQuery();

  const [rows, setRows] = useState<any[]>(data);

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = async (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = rows.findIndex((r: any) => r.id === active.id);
    const newIndex = rows.findIndex((r: any) => r.id === over.id);
    const updated = [...rows];
    const [moved] = updated.splice(oldIndex, 1);
    updated.splice(newIndex, 0, moved);
    setData(updated);

    const payload = updated.map((item, index) => ({
      id: item?.id,
      order: index,
    }));

    try {
      let response;
      response = await setOrder(payload).unwrap();

      if (response?.status === 200) {
        showToast(response?.message || "");
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeButterflyStatusApi = async (id: string) => {
    try {
      const response = await changeStatus({ id }).unwrap();
      if (response.status === 200) {
        butterflyEffectApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (data?.length) {
      setRows(data);
    } else {
      setRows([]);
    }
  }, [data]);

  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={rows.map((r: any) => r.id)}
          strategy={verticalListSortingStrategy}
        >
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Category</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Show</TableCell>
                  <TableCell>Drag & Drop</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.length ? (
                  rows?.map((row: any, i: any) => (
                    <TableRow key={i}>
                      <TableCell>
                        <p>{row?.category?.name || "-"}</p>
                      </TableCell>
                      <TableCell>
                        <p>{row?.title || "-"}</p>
                      </TableCell>
                      <TableCell>
                        <p>
                          {row?.butterflyEffectStartDate
                            ? formatDubaiDateTime(row?.butterflyEffectStartDate)
                            : "-"}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p>
                          {row?.butterflyEffectEndDate
                            ? formatDubaiDateTime(row?.butterflyEffectEndDate)
                            : "-"}
                        </p>
                      </TableCell>
                      <TableCell>
                        <IosSwitchMain
                          checked={row?.isShowEffect}
                          onChange={() => changeButterflyStatusApi(row?.id)}
                        />
                      </TableCell>

                      <TableCell>
                        <DraggableRow key={row.id} id={row.id}>
                          <IconButton>
                            <MenuIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </DraggableRow>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </SortableContext>
      </DndContext>
    </>
  );
};

export default ButterflyEffectTable;
